export const getCommonContent = () => ({
  trademarkTitle: 'trademark-text',
  trademarksTitle: 'trademarks-text',
  trademarkSelectPlaceholder: 'select-trademark-placeholder',
  trademarkTypeTitle: 'trademark-type-title',
  logoTrademarkTitle: 'logo-tm-placeholder',
  figurativeTrademarkTitle: 'figurative-tm-placeholder',
  wordTrademarkTitle: 'word-tm-placeholder',
  combinedTrademarkTitle: 'combined-tm-placeholder',
  trademarkNameTitle: 'trademark-name-title',
  trademarkLogoTitle: 'trademark-logo-title',
  trademarkNumberTitle: 'trademark-number-title',
  trademarkNumberPlaceholder: 'trademark-number-placeholder',
  trademarkInternationalNumberTitle: 'trademark-international-number-title',
  registrationNumberTitle: 'registration-number-title',
  registrationNumberPlaceholder: 'registration-number-placeholder',
  countryOfRegistrationTitle: 'country-of-registration-title',
  countryOfRegistrationPlaceholder: 'country-of-registration-placeholder',
  websiteLabel: 'website-label',
  websitesLabel: 'websites-title',
  websiteUrlOptionalLabel: 'website-url-optional-label',
  websiteUrlPlaceholder: 'website-url-placeholder',
  websitesTitle: 'websites-title',
  officialWebsiteTitle: 'official-website-title',
  capturedOnLabel: 'captured-on-label',
  capturedOnOptionalLabel: 'captured-on-optional-label',
  setTodayButton: 'set-today-button',
  fileTitle: 'file-text',
  transliterationTitle: 'transliteration-text',
  disclaimerTitle: 'disclaimer-text',
  meaningTitle: 'meaning-text',
  descriptionTitle: 'description-text',
  descriptionPlaceholder: 'description-placeholder',
  translationTitle: 'translation-text',
  individualDetailsTitle: 'name-portrait-signature-of-individual-text',
  miscellaneousStatementTitle: 'miscellaneous-statement-text',
  typeLabel: 'type-text',
  includingTextLabel: 'including-text',
  includingTextPlaceholder: 'including-text-placeholder',
  includingTextEmptyPlaceholder: 'including-text-empty-placeholder',
  countryTitle: 'country-text',
  countriesTitle: 'countries-text',
  noteTitle: 'note-label',
  registrationDateText: 'registration-date-text',
  statusTitle: 'status-text',
  filingDateText: 'filing-date-text',
  expirationDateText: 'expiration-date-text',
  dateFormatHelper: 'date-format-helper',
  dateOfFirstUseAnywhereLabel: 'date-of-first-use-anywhere-title',
  dateOfFirstUseInCommerceLabel: 'date-of-first-use-in-commerce-title',
  useInCommerceDayTooltipText: 'use-in-commerce-day-tooltip',
  useInCommerceMonthTooltipText: 'use-in-commerce-month-tooltip',
  officeTitle: 'office-title',
  classTitle: 'class-text',
  classesTitle: 'classes-text',
  classNameTitle: 'class-name-title',
  classItemsTitle: 'class-items-title',
  classSelectPlaceholder: 'select-class-placeholder',
  numberOfClassesLabel: 'number-of-classes-label',
  mainClassesTitle: 'main-classes-title',
  itemsTitle: 'items-text',
  priorityLabel: 'priority-title',
  priorityPlaceholder: 'priority-select-placeholder',
  numberLabel: 'number-title',
  filingNumberLabel: 'filing-number-title',
  filingNumberPlaceholder: 'filing-number-placeholder',
  jurisdictionLabel: 'jurisdiction-title',
  jurisdictionPlaceholder: 'jurisdiction-select-placeholder',
  trademarkDetailsTitle: 'trademark-details-text',
  domainNameTitle: 'domain-title',
  domainNamePlaceholder: 'domain-placeholder',
  freeTitle: 'free-title',
  saveButton: 'button-save',
  saveChangesButton: 'button-save-changes',
  cancelButton: 'button-cancel',
  addButton: 'button-add',
  editButton: 'button-edit',
  attachFileButton: 'attach-file-button',
  removeButton: 'button-remove',
  closeButton: 'close-btn-text',
  menuLabel: 'navigation-menu-label',
  skipToContentLink: 'page.skip-to-content-link',
  finishButton: 'finish-btn-text',
  sendButton: 'button-send',
  backButton: 'button-back',
  continueButton: 'button-continue',
  resolveButton: 'resolve-text',
  approveButton: 'approve-text',
  gotItButton: 'got-it-button',
  confirmButton: 'button-confirm',
  loadingTitle: 'loading-title',
  apiErrorMessage: 'api-error-description',
  firstNameLabel: 'contact-name',
  firstNamePlaceholder: 'contact-name-placeholder',
  lastNameLabel: 'contact-surname',
  lastNamePlaceholder: 'contact-surname-placeholder',
  emailLabel: 'contact-email',
  emailPlaceholder: 'contact-email-placeholder',
  messageLabel: 'message-label',
  messageOptionalLabel: 'message-optional-label',
  serviceTitle: 'service-text',
  servicePlaceholder: 'service-selection-placeholder',
  howItWorksTitle: 'how-it-works-title',
  whyTramaTitle: 'why-trama-title',
  unsavedChangesDescription: 'unsaved-changes-description',
  savingFormDescription: 'saving-form-description',
  changesSavedDescription: 'changes-saved',
  noResultsTitle: 'no-results-found',
  copyToClipboardText: 'copy-to-clipboard-text',
  copiedToClipboardText: 'copied-to-clipboard-text',
  requestTitle: 'request-title',
  clientText: 'client-text',
  viewAllButton: 'view-all-title',
  nameTitle: 'name-title',
  categoriesTitle: 'categories-title',
  ownedByTitle: 'owned-by-title',
  relatedArticlesTitle: 'related-articles-title',
  fromOurBlogTitle: 'from-our-blog-title',
  countrySearchPlaceholder: 'search-country-placeholder',
  industryTitle: 'industry-title',
  industrySelectPlaceholder: 'select-your-industry-placeholder',
  sectorTitle: 'sector-title',
  sectorSelectPlaceholder: 'select-your-sector-placeholder',
  faqsTitle: 'frequently-asked-questions-title',
  saveAndContinueButton: 'button-save-and-continue',
  allCountriesServedTitle: 'all-countries-served-title',
  notAvailableTitle: 'not-available-title',
  submitButton: 'button-submit',
  copyText: 'copy-text',
  moveText: 'move-text',
  selectedClassesTitle: 'selected-classes-title',
  loadingPaymentTitle: 'loading-payment-details',
  brandTitle: 'brand-title',
  brandPlaceholder: 'brand-placeholder',
  brandSelectPlaceholder: 'brand-select-placeholder',
  invoiceTitle: 'inv-title',
  nextTitle: 'next-btn-text',
  errorVpnAccessDisabled: 'error-vpn-access-disabled',
  optionYes: 'option-yes',
  optionNo: 'option-no',
  linkLabel: 'link-label',
  addAnotherTitle: 'add-another-title',
  recommendedTitle: 'recommended-title',
  buyTitle: 'buy-title',
  moreInfoTitle: 'more-info-title',
  fromTitle: 'offering-from-text',
  seeMoreTitle: 'see-more-title',
  learnMoreText: 'learn-more-text',
  inProgressTitle: 'in-progress-title',
  contentsTitle: 'contents-title',
  startWithLawyerCheckTitle: 'button-start-with-lawyer-check',
  showMoreButton: 'show-more-text',
  showLessButton: 'show-less-text',
  searchPlaceholder: 'search-placeholder',
  threadCommentAttachmentSupportedFormats: 'thread-comment-attachment-supported-formats',
  poaInProgressNote: {
    lawyer: 'poa-template-in-progress-note-lawyer',
    client: 'poa-template-in-progress-note-client',
  },
  ipOfficePriceIncreaseDescription: 'ip-office-price-increase-desc',
  doneTitle: 'button-done',
  allDoneTitle: 'all-done-title',
  errorOccurredTitle: 'error-occurred-title',
})
